import { ThemeProvider } from "@mui/material/styles";
import { HeatReportPage } from "./HeatReportPage";
import { HeatReportProvider } from "./context/HeatReportContext";
import heatReportStyles from "./styles/useHeatReportStyles";

const HeatReport = () => {
  return (
    <HeatReportProvider>
      <ThemeProvider theme={heatReportStyles}>
        <HeatReportPage />
      </ThemeProvider>
    </HeatReportProvider>
  );
};

export default HeatReport;
